/**
 * @class BaseInProductPackagePriceData
 */
export default class BaseInProductPackagePriceData {
    /**
     * @param {Number} id
     * @param {String} displayName
     * @param {String} size
     * @param {Object} purchase
     * @param {Object} sell
     * @param {Object} vat
     * @param {Object} surcharge
     * @param {Object} margins
     */
    constructor(id, displayName, size, purchase, sell, vat, surcharge, margins, posCoeficient) {
        this._id = id;
        this._displayName = displayName;
        this._size = size;
        this._sell = sell;
        this._purchase = purchase;
        this._vat = vat;
        this._surcharge = surcharge;
        this._margins = margins;
        this._posCoeficient = posCoeficient;

        if (
            this._purchase === undefined ||
            this._purchase === null ||
            this._sell === undefined ||
            this._sell === null ||
            this._vat === undefined ||
            this._vat === null ||
            this._surcharge === undefined ||
            this._surcharge === null ||
            this._posCoeficient === undefined ||
            this._posCoeficient === null
        ) {
            throw new Error("Price data is null.");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get displayName() {
        return this._displayName;
    }

    /**
     * @param {String} displayName
     */
    set displayName(displayName) {
        this._displayName = displayName;
    }

    /**
     * @return {String}
     */
    get size() {
        return this._size;
    }

    /**
     * @param {String} size
     */
    set size(size) {
        this._size = size;
    }

    /**
     * @return {Object}
     */
    get purchase() {
        return this._purchase;
    }

    /**
     * @param {Object}  purchase
     */
    set purchase(purchase) {
        this._purchase = purchase;
    }

    /**
     * @return {Object}
     */
    get sell() {
        return this._sell;
    }

    /**
     * @param {Object}  sell
     */
    set sell(sell) {
        this._sell = sell;
    }

    /**
     * @return {Object}
     */
    get vat() {
        return this._vat;
    }

    /**
     * @param {Object}  vat
     */
    set vat(vat) {
        this._vat = vat;
    }

    /**
     * @return {Object}
     */
    get surcharge() {
        return this._surcharge;
    }

    /**
     * @param {Object}  surcharge
     */
    set surcharge(surcharge) {
        this._surcharge = surcharge;
    }

    /**
     * @return {Object}
     */
    get margins() {
        return this._margins;
    }

    /**
     * @param {Object}  margins
     */
    set margins(margins) {
        this._margins = margins;
    }

    /**
     * @return {Object}
     */
    get posCoeficient() {
        return this._posCoeficient;
    }

    /**
     * @param {Object}  posCoeficient
     */
    set posCoeficient(posCoeficient) {
        this._posCoeficient = posCoeficient;
    }
}
